import React from "react";

const BorderWrapper = (props) => {
  const { children, styles = "p-4 rounded-xl shadow-default-card" } = props;
  return <div className={styles}>{children}</div>;
};

export default BorderWrapper;
